import api from '../../api';

const state = {
  coach: null,
};

// getters
const getters = {
  hasCoach: (state) => (!!state.coach),
};

// mutations
const mutations = {
  removeCoach(state) {
    state.coach = null;
  },

  setCoach(state, { coach }) {
    state.coach = coach;
  },
};

// actions
const actions = {
  async fetchCoach({ commit }) {
    // empty user data
    // commit('removeCoach');

    try {
      const response = await api.getMyCoach();
      if (response.data) {
        commit('setCoach', {
          coach: response.data,
        });
      } else {
        commit('removeCoach');
      }

      return response.data;
    } catch (err) {
      commit('removeCoach');
      return null;
    }
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
